import angular from 'angular';
import 'angular-ui-router';
import 'ng-file-upload/dist/ng-file-upload';
import 'angular-modal-service';
import Filters from '../../filters/filters.js';
import template from '../campaigns/sspMarginForm.jade';
import ConfigsModule from '../../configs/configs.js';
import ServicesModule from '../../services/services.js';
import FiltersModule from '../../filters/filters.js';

export class SspMarginFormController {
  /* @ngInject */
  constructor($scope, $filter) {
    this.$scope = $scope;
    this.translate = $filter('translate');
  }

  getSspMarginName() {
    const res = this.sspTypeOptions.find(option => option.id === this.sspMargin.ssp_id);
    return res.name || '';
  }

  removeSspMargin() {
    let indexOfSspMarginToRemove = _.findIndex(this.campaign.ssp_fees, (sspMargin) => {return sspMargin.name === this.sspMargin.name;});
    if (indexOfSspMarginToRemove > -1) {
      this.campaign.ssp_fees.splice(indexOfSspMarginToRemove,1);
    }
  }

}

let SspMarginFormComponent = {
  template: () => { return template },
  controller: SspMarginFormController,
  controllerAs: 'vm',
  bindings: {
    campaign: '=',
    sspMargin: '=',
    sspTypeOptions: '=',
  }
};

export default angular.module('app.components.campaigns.sspMarginForm', [
  ConfigsModule.name,
  ServicesModule.name,
  Filters.name,
  FiltersModule.name
])
  .component('sspMarginForm', SspMarginFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/sspMarginForm.js
 **/